import { ClassicType } from '../../shared/models/ClassicType';
import {ProvaAcquisto} from "../../rma/_Models/prova-acquisto";
export class Sede {
  id?: number;
  cliente?: number;
  tipiSede?: number[];
  tipiObject?: ClassicType[];
  indirizzo?: string;
  cap?: string;
  citta?: string;
  provincia?: string;
  email?: string;
  telefono?: string;
  fax?: string;
  note?: string;
  lat?: number;
  lon?: number;
  fullAddress?: string;
  principale?: boolean;
  prove?: ProvaAcquisto[];

  /*
  "cliente"   : 14,
    "tipiSede"  : [29],
    "indirizzo" : "Via ciccio",
    "cap"       : "34000",
    "citta"     : "Bari",
    "provincia" : "BA",
    "email"     : "",
    "telefono"  : "",
    "fax"       : "",
    "note"      : "",
    "lat"       : 12.3456,
    "lon"       : 12.3456
     "id"        : 1,
  */
  codAdhoc?: any;
  regione?: any;

}
